import { Icon, Row, Spin } from 'antd';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { addOrder } from './../../../actions/addOrder';
import { keepState } from './../../../actions/appAction';
import * as editOrder from './../../../actions/editOrder';
import { getShipmentById } from './../../../actions/shipmentAction';
import lang from './../../../languages/en';
import { informationClassesDefault, informationDefault } from './../../../reducers/helper/stateDefaultOrder';
import { alertError } from './../../../services/dialog';
import { convertDateToUTC } from './../../../services/dst';
import { titleHead } from './../../../services/helper';
import history from './../../../services/history';
import OrderComponent from './../components';
import TranslationItemName from './../components/translation-item-name';
import Items from './components/items';
import ListModal from './components/modal';
import OrderInformation from './components/order-information';
import ShipTo from './components/ship-to';
import ShipmentOptions from './components/shipment-options';
import ShipmentRemark from './components/shipment-remark';
import './styles.css';
import { getListProhibitedItems } from './../../../utils/prohibitedItems';
import hanldeException from '../../../services/handleException';
import { shipperInfor } from '../../../actions/shipperInfor';
import { needCollectAmountTerms, FulfillOption as FulfillOptionConst } from '../../../constants';

class EditOrder extends OrderComponent {
    constructor(props) {
        super(props)
        this.state = {
            visibleTranslationItemName: true,
            listItemMapping: [],
            prohibitedItems:[]
        }
        this.validateDidMount()
    }

    componentDidMount() {
        titleHead('Edit Order')
        this.settingMappingItemName()
        this.props.onChange({ value: true, column: 'isLoading' })
        let _this = this;
        getListProhibitedItems().then(res => {
            if (res.data.code === 10001) {
                _this.setState({
                    prohibitedItems: res.data.data.ProhibitedKeyWords
                })
            }
            _this.loadDataInit()
        }).catch(err => {
            hanldeException(err)
            _this.loadDataInit()
        })
    }

    loadDataInit = () => {
        this.props.shipperInfor()
        if (this.props.addOrderInShipment) {
            let shipment_id = this.getShipmentId()
            this.props.getShipmentById(shipment_id)
        } else {
            let order_id = this.getOrderId()
            this.props.editOrder(order_id)
        }
    }

    onSaveOrders = (value) => {
        const { order } = this.props;
        let data = this.convertData(value);
        if(!needCollectAmountTerms.includes(data.PaymentTerm))
        {
            data.CollectAmount = 0;
        }
        this.props.onChange({ value: true, column: 'isLoading' })
        if (this.props.addOrderInShipment) {
            data.status_list = history.location.state.status_list ? history.location.state.status_list : []
            this.props.addOrderFromShipment(data)
        } else {
            if (JSON.stringify(order.information) === JSON.stringify(order.informationOrigin)
                && JSON.stringify(order.items) === JSON.stringify(order.itemsOrigin)) {
                this.props.onChange({ value: false, column: 'isLoading' })
                history.push('/orders')
                return false;
            }
            this.props.updateOrder(data)
        }
        this.props.onChange({ value: false, column: 'confirm_save_order' })
    }

    convertData = (value) => {
        let order_id = this.getOrderId()
        let information = this.props.information
        let itemNew = this.convertItems(value)

        let data = {
            ChannelOrderID: information['channel_order'],
            ChannelOrderCH: information['channel'],
            OrderDate: convertDateToUTC(moment(information['order_date']).format('YYYY-MM-DD HH:mm')).format('YYYY-MM-DD HH:mm'),
            DeliveryTime: information['preferred_time'] ? information['preferred_time'].toString() : '00',
            PaymentTerm: information['terms'],
            Currency: information['currency'],
            ConsigneeName: information['name'],
            ConsigneeKanaNameCH: information['yomigana'],
            ConsigneePhone: information['phone'],
            ConsigneeEmail: information['email'],
            ConsigneeCountry: information['country'],
            ConsigneeAddress1: information['address1'],
            ConsigneeAddress2: information['address2'],
            ConsigneeAddress3: information['address3'],
            ConsigneeAddress4: information['address4'],
            ConsigneePostalCode: information['postal_code'] ? information['postal_code'].toString() : '',
            AddressType: information['address_type'],
            Items: itemNew,
            OrderID: Number(order_id),
            order_id,
            ChangeItemOrder: this.props.order.mappingOrderSameSku,
            LastUpdateOrderDT: information['LastUpdateOrderDT'],
            FulfillmentOption: information['FulfillmentOption'],
            CollectAmount: parseFloat(information['CollectAmount']),
            Remark: information['Remark'],
            HandlingCharge: information['HandlingCharge'],
            NoOfPackages: information['NoOfPackages'] && information['FulfillmentOption'] === FulfillOptionConst.IN_HOUSE.CODE ? Number(information['NoOfPackages']) : 1
        }
        return data;
    }

    confirmSaveOrder = () => {
        const { itemOrder } = this.props

        if (itemOrder.length < 1) {
            alertError(lang.item_required_least_one)
            return;
        }
        if (!this.validateRequired('save')) {
            alertError(lang.field_some_required)
            return;
        }
        if (!this.validateError()) {
            if (this.props.addOrderInShipment) {
                this.props.onChange({ value: true, column: 'confirm_save_order' })
            } else {
                alertError(lang.order_cannot_saved_because_some_fields_invaild, lang.order_cannot_saved_because_some_fields_invaild_line_2)
            }

            return;
        }
        this.confirmItemNameMapping('editOrder');
    }

    getOrderId = () => {
        let url = window.location.href
        let order_id = url.split('order_id=')[1]
        return order_id;
    }

    getShipmentId = () => {
        let url = window.location.href
        let shipment_id = url.split('shipment_id=')[1]
        return shipment_id;
    }

    validateDidMount = () => {
        this.props.stateInformationClassesDefault(informationClassesDefault())
        this.props.stateInformationDefault(informationDefault())
    }

    cancelTranslationItemName = (value) => {
        this.setState({
            visibleTranslationItemName: value
        })
    }

    render() {
        let pageType = 'addOrderInShipment';
        const { addOrderInShipment } = this.props
        if (!addOrderInShipment) {
            pageType = 'editOrder'
        }
        return (
            <Spin tip='Loading' spinning={this.props.order.isLoading}>
                <div id="add-order">
                    <div className="edit-title">{pageType !== 'editOrder' ? 'Create Order' : 'Edit Order'}</div>
                    <Icon className='close-order-animation' onClick={() => {
                        if (pageType === 'addOrderInShipment') {
                            history.goBack()
                            this.props.keepState(true)
                        } else {
                            history.push('/orders')
                            this.props.keepState(true)
                        }
                    }} type="close" theme="outlined"
                    />
                    <Row className='content-add-order'>
                        <OrderInformation
                            onBlur={this.onBlur}
                            validateEmpty={this.validateEmpty}
                            pageType={pageType}
                            onFocus={this.onFocus}
                        />
                        <Row gutter={8} className='ship-to-shipment-option'>
                            <ShipTo
                                onBlur={this.onBlur}
                                onFocus={this.onFocus}
                                validateEmpty={this.validateEmpty}
                                pageType={pageType}
                            />
                            <ShipmentOptions
                                onBlur={this.onBlur}
                                pageType={pageType}
                                onFocus={this.onFocus}
                            />
                        </Row>
                        <Row className='shipment-remark'>
                            <ShipmentRemark
                                    onBlur={this.onBlur}
                                    pageType={pageType}
                                    onFocus={this.onFocus}
                            />
                        </Row>
                        <Row>
                            <Items
                                prohibitedItems={this.state.prohibitedItems}
                                validateEmpty={this.validateEmpty}
                                pageType={pageType}
                                maxSizeSku={this.state.maxSizeSku}
                            />
                        </Row>
                        <ListModal
                            confirmSaveOrder={this.confirmSaveOrder}
                            onSaveOrders={this.onSaveOrders}
                            pageType={pageType}
                            order_id={this.getOrderId()}
                            prohibitedItems={this.state.prohibitedItems}
                        />
                    </Row>
                    <TranslationItemName
                        listItemMapping={this.state.listItemMapping}
                        ref={e => this.translationItemNameRef = e}
                        onChange={this.props.onChange}
                        order={this.props.order}
                        confirmMapping={this.confirmMapping}
                        confirmTypeMapping={this.confirmTypeMapping}
                        pageType='editOrder'
                    />
                </div>
            </Spin>
        )
    }
}

const mapStateToProps = state => {
    return {
        isDisable: state.editOrder.isDisable,
        confirm_save_order: state.editOrder.confirm_save_order,
        itemOrder: state.editOrder.items,
        order: state.editOrder,
        information: state.editOrder.information,
        shipperInformation: state.editOrder.shipperInformation,
        classes: state.editOrder.classes
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChange: payload => {
            dispatch(editOrder.changeEditOrder(payload))
        },
        onChangeItem: payload => {
            dispatch(editOrder.changeItemEditOrder(payload))
        },
        onChangeClasses: payload => {
            dispatch(editOrder.changeClassesEditOrder(payload))
        },
        editOrder: payload => {
            dispatch(editOrder.editOrder(payload))
        },
        updateOrder: payload => {
            dispatch(editOrder.updateOrder(payload))
        },
        addOrder: payload => {
            dispatch(addOrder(payload))
        },
        getShipmentById: payload => {
            dispatch(getShipmentById(payload))
        },
        addOrderFromShipment: payload => {
            dispatch(editOrder.addOrderFromShipment(payload))
        },
        onChangeInformation: payload => {
            dispatch(editOrder.changeInforEditOrder(payload))
        },
        stateInformationDefault: payload => {
            dispatch(editOrder.stateInformationDefaultEditOrder(payload))
        },
        stateInformationClassesDefault: payload => {
            dispatch(editOrder.stateInformationClassesDefaultEditOrder(payload))
        },
        keepState: payload => {
            dispatch(keepState(payload))
        },
        shipperInfor: payload => {
            dispatch(shipperInfor(payload))
        },
        convertName: payload => {
            dispatch(editOrder.convertNameEditOrder(payload))
        }

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditOrder)



// WEBPACK FOOTER //
// ./src/containers/orders/edit/index.js